import { useMemo } from 'react';
import { useGetMotoboys } from '../api/get-motoboys';
import type { IMotoboyNames } from '../types';

interface GetMotoboysProps {
  nameDeliveryMan?: string;
  municipioId?: string;
}

function useMotoboys({ nameDeliveryMan, municipioId }: GetMotoboysProps) {
  const getMotoboys = useGetMotoboys(
    { nameDeliveryMan, municipioId },
    {
      enabled: !!nameDeliveryMan,
      staleTime: 1000 * 60 * 5,
    },
  );

  const motoboysOptions = useMemo(() => {
    if (!getMotoboys.data?.length) return [];
    return getMotoboys.data?.map((item: IMotoboyNames) => ({
      key: item._id,
      text: item.nome,
      value: item._id,
    }));
  }, [getMotoboys.data]);

  return { getMotoboys, motoboysOptions };
}

export { useMotoboys };
